export default __webpack_public_path__ + "static/media/march-2020.c76a0f42.csv";